<template>
  <div>
    <!-- Filters Toolbar -->
    <form @submit.prevent>
      <div class="has-background-white rounded-lg pa-md mb-xxs">
        <div class="columns">
          <div class="column">
            <b-select v-model="organization" expanded size="is-medium" placeholder="Select Organization...">
              <option v-for="organization in organizations" :key="organization.id" :value="organization">{{ organization.name }}</option>
            </b-select>
          </div>
          <div class="column is-one-fifth">
            <b-select v-model="year" expanded @input="loadBillingPeriods" size="is-medium">
              <option value="2025-01-01">2025</option>
              <option value="2024-01-01">2024</option>
              <option value="2023-01-01">2023</option>
            </b-select>
          </div>
          <div class="column is-one-fifth">
            <b-select v-model="startBillingPeriod" expanded size="is-medium">
              <option v-for="period in billingPeriods" :key="period.id" :value="period">{{ period.label }}</option>
            </b-select>
          </div>
          <div class="column is-one-fifth">
            <b-select v-model="endBillingPeriod" expanded size="is-medium">
              <option v-for="period in billingPeriods" :key="period.id" :value="period">{{ period.label }}</option>
            </b-select>
          </div>
          <div class="column is-narrow">
            <b-button native-type="submit" size="is-medium" type="is-primary" @click="loadReport" outlined>Run</b-button>
          </div>
        </div>
      </div>
    </form>
    <table v-if="metrics.length && billingPeriods.length" class="table is-fullwidth">
      <tr>
        <th class="is-size-8">Metric</th>
        <th v-for="period in billingPeriods" :key="period.id" class="is-size-8 has-text-right">{{ period.short_label }}</th>
      </tr>
      <tr v-for="(row, index) in rows" :key="index">
        <td class="is-size-8">{{ row.label }}</td>
        <td v-for="(metric, index) in metrics" :key="index" class="is-size-8 has-text-right">
          <Currency :value="metric[row.key]" />
        </td>
      </tr>
    </table>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  computed: {
    ...mapGetters(['api']),
    ready () {
      return Boolean(this.organization && this.startBillingPeriod && this.endBillingPeriod)
    }
  },
  data () {
    return {
      loadingOrganizations: true,
      loadingBillingPeriods: true,
      organizations: [],
      billingPeriods: [],
      year: '2025-01-01',
      startBillingPeriod: null,
      endBillingPeriod: null,
      organization: null,
      loadingReport: false,
      results: [],
      metrics: [],
      rows: [{
        label: 'Pending',
        key: 'amount_pending'
      }, {
        label: 'Pending (Cost)',
        key: 'amount_pending_cost'
      }, {
        label: 'Delivered',
        key: 'amount_fulfilled'
      }, {
        label: 'Delivered (Cost)',
        key: 'amount_fulfilled_cost'
      }, {
        label: 'Scheduled',
        key: 'amount_scheduled'
      }, {
        label: 'Billed',
        key: 'amount_billed'
      }, {
        label: 'Expenses',
        key: 'amount_expenses_billable'
      }, {
        label: 'Expenses (Pending)',
        key: 'amount_expenses_pending'
      }, {
        label: 'Expenses (Billable)',
        key: 'amount_expenses_billable'
      }, {
        label: 'Expenses (Non-Billable)',
        key: 'amount_expenses_nonbillable'
      }]
    }
  },

  // amount_pending:"0.0000"
  // amount_pending_cost:"0.0000"
  // amount_scheduled:"0.0000"

  methods: {
    loadOrganizations () {
      const endpoint = this.api.route + '/organizations'
      this.loadingOrganizations = true
      this.$http.get(endpoint).then(response => {
        this.organizations = response.data.data
      })
    },
    loadBillingPeriods () {
      this.loadingBillingPeriods = true
      const start = this.$dates(this.year).startOf('year')
      const end = this.$dates(this.year).endOf('year')
      const endpoint = this.api.base + 'billing-periods'
      const query = {
        params: {
          start: start.format('YYYY-MM-DD'),
          end: end.format('YYYY-MM-DD'),
          order_by: 'asc'
        }
      }
      this.$http.get(endpoint, query).then(response => {
        this.billingPeriods = response.data
        this.startBillingPeriod = this.billingPeriods[0]
        this.endBillingPeriod = this.billingPeriods[this.billingPeriods.length - 1]
      })
    },
    loadReport () {
      this.loadingReport = true
      const endpoint = this.api.route + '/admin/reports/organization-period'
      const query = {
        params: {
          organization_id: this.organization.id,
          start_billing_period_id: this.startBillingPeriod.id,
          end_billing_period_id: this.endBillingPeriod.id
        }
      }
      this.$http.get(endpoint, query).then(response => {
        this.metrics = []
        this.data = response.data
        this.billingPeriods.forEach(period => {
          this.data.data.forEach(organizationPeriod => {
            if (period.id === organizationPeriod.billing_period_id) {
              this.metrics.push({
                billing_period_id: period.id,
                amount_funded: organizationPeriod.amount_funded,
                amount_budgeted: organizationPeriod.amount_budgeted,
                amount_allocated: organizationPeriod.amount_allocated,
                amount_allocated_cost: organizationPeriod.amount_allocated_cost,
                amount_pending: organizationPeriod.amount_pending,
                amount_pending_cost: organizationPeriod.amount_pending_cost,
                amount_fulfilled: organizationPeriod.amount_fulfilled,
                amount_fulfilled_cost: organizationPeriod.amount_fulfilled_cost,
                amount_expenses_pending: organizationPeriod.amount_expenses_pending,
                amount_expenses_billable: organizationPeriod.amount_expenses_billable,
                amount_expenses_nonbillable: organizationPeriod.amount_expenses_nonbillable,
                amount_scheduled: organizationPeriod.amount_scheduled,
                amount_billed: organizationPeriod.amount_billed
              })
            }
          })
        })
        this.loadingReport = false
      })
    }
  },
  mounted () {
    this.loadOrganizations()
    this.loadBillingPeriods()
  }
}
</script>
